import React, { useRef, useEffect, useState, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import ErrorLabel from "../../../../component/error_label";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import { useDropzone } from "react-dropzone";
import RtoDropdown from "../new_vehicles/rto.json";
import { actionAddNewVehicle, actionValidateVehicle, resetAddNewVehicle, resetvalidateVehicle, actionuploadDocument, resetuploadDocument } from "./store";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../../../common/app_constant";
import toast from "react-hot-toast";
import { actionSourceForEnquiry, resetGetSource } from "../policies/store";
import { capitalizeFirstLetter } from "devextreme-react/cjs/core/helpers";
import Swal from 'sweetalert2';
import Loader from "../../../../component/page_loader";
import { PJ_URL } from "../../../../common/constant";

const NewVehicle = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    formState: { errors },
    control,
  } = useForm({ defaultValues: { vehicle_type: 'corporate', noc_type: null } });
  const [isLoader, setIsLoader] = useState(false);

  const [getSourceDetails, setGetSourceDetails] = useState(null);
  const [showNOCField, setShowNOCField] = useState(false)

  const [copySuccess, setCopySuccess] = useState('');
  const textAreaRef = useRef(null);

  const watchVehicleType = watch('vehicle_type')

  const watchNocType = watch('noc_type')

  const { addNewVehicle, validateVehicle, uploadDocument } = useSelector((state) => ({
    ...state.AddNewVehicleStore,
  }));

  const { getSource } = useSelector(state => ({
    ...state.policyStore,
  }));
  const [attachment, setAttachment] = useState([]);
  // function to split fullname into  parts
  const splitFullName = (fullName) => {

    // Split the full name into words
    const nameParts = fullName.split(' ');

    // Initialize variables for first, middle, and last names
    let firstName = '';
    let middleName = '';
    let lastName = '';

    // Assign values based on the number of name parts
    if (nameParts.length === 1) {
      // If only one part, consider it as the first name
      firstName = nameParts[0];
    } else if (nameParts.length === 2) {
      // If two parts, consider the first as the first name and the second as the last name
      firstName = nameParts[0];
      lastName = nameParts[1];
    } else {
      // If three or more parts, consider the first as the first name,
      // the last as the last name, and the rest as the middle name
      firstName = nameParts[0];
      lastName = nameParts[nameParts.length - 1];
      middleName = nameParts.slice(1, -1).join(' ');
    }

    // Return an object with the extracted names
    return {
      first_name: firstName,
      middle_name: middleName,
      last_name: lastName,
      full_name: fullName
    };

  }

  const initialRender = () => {

    const userDataString = localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      if (!!userData.full_name) {
        const {
          first_name, middle_name, last_name, full_name
        } = splitFullName(userData.full_name.trim());
        setValue("first_name", first_name);
        setValue("last_name", last_name);
      }

      setValue("mobile", userData.mobile);
      setValue("email", userData.email);

    }
  };


  useEffect(() => {
    initialRender();
  }, []);

  useEffect(() => {
    if (watchVehicleType) {
      dispatch(actionSourceForEnquiry({
        type: 'new',
        value: capitalizeFirstLetter(watchVehicleType)
      }));
    }
  }, [watchVehicleType]);

  useEffect(() => {
    if (getSource) {
      dispatch(resetGetSource());
      if (getSource.status === true) {
        setGetSourceDetails(getSource?.data)
      } else {
        setGetSourceDetails(null)
      }
    }
  }, [getSource])

  useEffect(() => {
    if (addNewVehicle !== null) {
      dispatch(resetAddNewVehicle());
      if (addNewVehicle?.status === true) {
        toast.success(addNewVehicle.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        navigate(-1);
      } else {
        switch (addNewVehicle?.status_code) {
          case 400:
            toast.error(addNewVehicle.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [addNewVehicle]);

  useEffect(() => {
    if (validateVehicle !== null) {
      dispatch(resetvalidateVehicle());
      setIsLoader(false);
      if (validateVehicle?.status === true) {
        if (validateVehicle?.status_code === 200) {
          const token = localStorage.getItem("token");
          const url = `${PJ_URL}?token=${token}&source=${getSourceDetails?.source}&quote_id=${getSourceDetails?.quoteId}`;
          console.log(url);
          window.open(url, '_blank');
          return
        } else if (validateVehicle?.status_code === 204) {
          if (watchVehicleType === 'corporate') {
            setShowNOCField(true)
          } else {
            setShowNOCField(false)
          }
          toast.success(validateVehicle.message, {
            duration: TOAST_DURATION,
            position: TOAST_POSITION,
            style: {
              color: TOAST_SUCCESS_COLOR,
            },
          })
        }
      }
      else {
        setShowNOCField(false)
        switch (validateVehicle?.status_code) {
          case 400:
            toast.error(validateVehicle.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login");
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [validateVehicle]);


  // useEffect(() => {
  //   if (uploadDocument !== null) {
  //     dispatch(resetuploadDocument());

  //     if (uploadDocument?.status === true) {
  //       toast.success(uploadDocument.message, {
  //         duration: TOAST_DURATION,
  //         position: TOAST_POSITION,
  //         style: {
  //           color: TOAST_SUCCESS_COLOR,
  //         },
  //       });
  //     } else {
  //       // Error handling with navigation to login for 400 and 401 status codes
  //       switch (uploadDocument?.status_code) {
  //         case 400:
  //           toast.error(uploadDocument.message, {
  //             duration: TOAST_DURATION,
  //             position: TOAST_POSITION,
  //             style: {
  //               color: TOAST_ERROR_COLOR,
  //             },
  //           });
  //           localStorage.clear();
  //           navigate("/login");
  //           break;
  //         case 401:
  //           localStorage.clear();
  //           navigate("/login", { replace: true });
  //           break;
  //         default:
  //           toast.error(uploadDocument.message, {
  //             duration: TOAST_DURATION,
  //             position: TOAST_POSITION,
  //             style: {
  //               color: TOAST_ERROR_COLOR,
  //             },
  //           });
  //       }
  //     }
  //   }
  // }, [uploadDocument]);

  useEffect(() => {
    console.log("uploadDocument:", uploadDocument);  // Check if it's being updated
    if (uploadDocument?.status === true) {
      setIsLoader(false);
      // console.log("Navigating to /thankyou");
      try {
        navigate("/thankyou", { replace: true });
      } catch (error) {
        console.error("Error navigating to /thankyou:", error);
      }

    }
  }, [uploadDocument]);


  const generateRTOList = () => {
    var menu = [];
    if (RtoDropdown.rto_json != null && RtoDropdown.rto_json.length > 0) {
      RtoDropdown.rto_json.forEach(function (child, labelIndex) {
        menu.push(
          <option key={labelIndex} value={child.id}>
            {child.RegNo}
          </option>
        );
      });
    }
    return menu;
  };

  const onDrop = useCallback((acceptedFiles) => {
    $("#order_attachment_error").removeClass("text-danger");
    $("#document-required").addClass("d-none");
    if (attachment.length < 1) {
      setAttachment([...attachment, ...acceptedFiles]);
    } else {
    }
  });

  const { getRootProps, getInputProps, fileRejections } = useDropzone({
    accept: {
      accept: [
  ".pdf",
  ".doc",
  ".docx",
  ".jpeg",
  ".jpg",
  ".png",
  ".xls",
  ".xlsx"
]

    },
    // multiple: true,
    maxFiles: 1,
    onDrop,
  });

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <ul className="danger" style={{ paddingInlineStart: "0px" }}>
      {errors.map((e) => (
        <li key={e.code}>{e.message}</li>
      ))}
    </ul>
  ));

  const removeFile = (file) => () => {
    const newFiles = [...attachment];
    newFiles.splice(newFiles.indexOf(file), 1);
    setAttachment(newFiles);
  };

  const removeAll = () => {
    setAttachment([]);
  };
  const thumbs = attachment.map((file) => (
    <>
      <div className="card mt-3" key={file.name}>
        <div className="card-body d-flex justify-content-between">
          <span className="my-auto"> {file.name} </span>
          <button
            type="reset"
            className="btn btn-sm btn-primary"
            onClick={removeFile(file)}
          >
            X
          </button>
        </div>
      </div>
    </>
  ));

  const onSubmit = async (data) => {
    // if (watchVehicleType === 'corporate' && watchNocType === 'false') {
    //   Swal.fire({
    //     icon: 'info',
    //     title: 'Info...',
    //     text: 'You cannot buy another corporate insurance policy, unless NOC is submitted against the existing policy.',
    //     confirmButtonText: 'Ok',
    //     confirmButtonColor: '#3085d6',  // You can customize this button color
    //   });
    //   return;
    // }

    console.log(typeof watchNocType, watchNocType, "...noc type");
    console.log(watchVehicleType, watchNocType, watchVehicleType === 'corporate' && watchNocType === "false");

    if (watchVehicleType === 'corporate' && watchNocType !== null && watchNocType === "false") {
      Swal.fire({
        icon: 'info',
        title: 'Info...',
        text: 'You cannot buy another corporate insurance policy, unless NOC is submitted against the existing policy.',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',  // You can customize this button color
      });
      return;
    }

    if (showNOCField && watchVehicleType !== 'personal') {
      var files = [];
      attachment.forEach((objImage, index) => {
        if (objImage != null) {
          files.push({
            name: "file",
            value: objImage,
          });
        }
      });

      if (attachment.length > 0 && watchNocType === "true") {
        $("#document-required").addClass("d-none");
        setIsLoader(true);
        dispatch(actionuploadDocument({ input: { type: 'Corporate' }, files }));
      } else {
        $("#document-required").removeClass("d-none");

        // navigate("/thankyou", { replace: true });
      }
    } else if ((watchVehicleType === 'corporate' || watchVehicleType === 'personal') && watchNocType !== "true") {
      var input = data?.vehicle_type.charAt(0).toUpperCase() + data.vehicle_type.slice(1);
      setIsLoader(true);
      dispatch(actionValidateVehicle({ type: input }));
    }


    // var input = {
    //   vehicle_type: data.vehicle_type,
    //   first_name: data.first_name,
    //   last_name: data.last_name,
    //   mobile: data.mobile,
    //   email: data.email,
    //   alt_contact: data.alt_contact,
    //   alt_email: data.alt_email,
    //   // rto_code: data.rto_code,
    //   // year_of_manufacturing: data.year_of_manufacturing,
    //   // make: data.make,
    //   // model: data.model,
    //   // variant: data.variant,
    //   // cubic_capacity: data.cubic_capacity,
    //   // fuel_type: data.fuel_type,
    //   // ex_showroom_price: data.ex_showroom_price,
    //   remarks: data.remarks,
    // };


  };
  // copy to clipboard



  return (
    <>
      <div className="row justify-content-center mb-5 mt-6">
        <h5 className="font-weight-bold cust-sm-h3 text-center mb-4">New / Personal Vehicle</h5>
        <div className="col-lg-8 col-md-12 shadow bg-white px-5 py-4 mb-4">

          <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            {/* <div className="mt-1 row">
              <label for="organization_name" className="form-label col-sm-4">
                Organization Name
              </label>
              <div className="col-sm-8">
              <input
                type="text"
                className="form-control"
                id="organization_name"
                {...register("organization_name", {
                  required: "This is required.",
                  maxLength: {
                    value: 200,
                    message:
                      " Organization Name cannot be greater than 30-chars.",
                  },
                })}
              />
              {errors.organization_name && (
                <ErrorLabel message={errors.organization_name?.message} />
              )}
              </div>
            </div> */}

            {/* <div className="mt-1 row">
              <label for="policy_type" className="col-sm-4 col-form-label">
                Policy Type
              </label>
              <div className="col-sm-8">
              <select
                id="policy_type"
                className="form-control form-select "
                {...register("policy_type", {
                  required: "This is required.",
                })}
              >
                <option value="">Policy Type</option>
                {generateLossType()}
              </select>
              {errors.policy_type && (
                <ErrorLabel message={errors.policy_type?.message} />
              )}
              </div>
            </div> */}
            <div className="mb-3">
              <div className="row">
                <label htmlFor="vehicle_type_corporate" className="form-label col-sm-4">
                  Vehicle Type
                </label>

                <div className="col-sm-4">
                  <input
                    className="form-check-input me-1"
                    type="radio"
                    name="vehicle_type"
                    id="vehicle_type_corporate"
                    value="corporate"
                    onClick={() => {
                      setValue("vehicle_type", "corporate")
                      setValue('noc_type', null)
                    }}
                    {...register("vehicle_type", {
                      required: "Please select vehicle type",
                    })}
                  />
                  <label className="form-check-label ml-1" htmlFor="vehicle_type_corporate">
                    Corporate
                  </label>
                </div>

                <div className="col-sm-4">
                  <input
                    className="form-check-input me-1"
                    type="radio"
                    name="vehicle_type"
                    id="vehicle_type_personal"
                    value="personal"
                    onClick={() => {
                      setValue('noc_type', 'false')
                      setValue("vehicle_type", "personal")
                    }}
                    {...register("vehicle_type", {
                      required: "Please select vehicle type",
                    })}
                  />
                  <label className="form-check-label ml-1" htmlFor="vehicle_type_personal">
                    Personal
                  </label>
                </div>
              </div>

              {/* Display error message if vehicle type is not selected */}
              <div className="row justify-content-center">
                <div className="col-4">
                  {errors.vehicle_type && (
                    <ErrorLabel message={errors.vehicle_type?.message} />
                  )}
                </div>
              </div>
            </div>

            {
              (showNOCField && watchVehicleType === 'corporate') && (
                <div className="mb-3">
                  <div className="row">
                    <label htmlFor="noc_type_yes" className="form-label col-sm-4">
                      Please confirm if NOC against the vehicle transfer is received
                    </label>

                    <div className="col-sm-4">
                      <input
                        className="form-check-input me-1"
                        type="radio"
                        name="noc_type"
                        id="noc_type_yes"
                        value="true"
                        {...register("noc_type", {
                          required: "Please select an option"
                        })}
                      />
                      <label className="form-check-label ml-1" htmlFor="noc_type_yes">
                        Yes
                      </label>
                    </div>

                    <div className="col-sm-4" onClick={() => {
                      Swal.fire({
                        icon: 'info',
                        title: 'Info...',
                        text: 'You cannot buy another corporate insurance policy, unless NOC is submitted against the existing policy.',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#3085d6',  // You can customize this button color
                      });
                    }}>
                      <input
                        className="form-check-input me-1"
                        type="radio"
                        name="noc_type"
                        id="noc_type_no"
                        value="false"
                        {...register("noc_type", {
                          required: "Please select an option"
                        })}
                      />
                      <label className="form-check-label ml-1" htmlFor="noc_type_no">
                        No
                      </label>
                    </div>
                  </div>

                  {/* Display error message for noc_type */}
                  <div className="row justify-content-center">
                    <div className="col-4">
                      {errors.noc_type && (
                        <ErrorLabel message={errors.noc_type?.message} />
                      )}
                    </div>
                  </div>
                </div>
              )
            }

            {
              (watchNocType === "true" && watchVehicleType === 'corporate') && (
                <div className="col-12 mt-4 text-center">
                  <div
                    {...getRootProps({ className: "dropzone" })}
                    className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
                  >
                    <span className="badge bg-primary rounded p-2">
                      <input accept="" {...getInputProps()} />
                      <i className="fa fa-plus" />
                    </span>{" "}
                    <span>Upload Invoice / Policy Related documents</span>
                  </div>
                  <span id="document-required" className="d-none text-danger fs-7 mx-auto">
                    Document is required
                  </span>
                  {thumbs}
                  {attachment.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-primary rounded mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        removeAll();
                      }}
                    >
                      Remove All
                    </button>
                  )}
                  {fileRejectionItems}
                </div>
              )
            }

            {/* <div className="mb-3 row">
              <label for="first_name" className="form-label col-sm-4">
                First Name <span className="text-danger">*</span>
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="first_name"
                  name="first_name"
                  onKeyDown={(event) => {
                    if (/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  {...register("first_name", {
                    required: "This is required.",
                  })}
                />
                {errors.first_name && (
                  <ErrorLabel message={errors.first_name?.message} />
                )}
              </div>
            </div> */}
            {/* <div className="mb-3 row">
              <label for="last_name" className="form-label col-sm-4">
                Last Name <span className="text-danger">*</span>
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="last_name"
                  name="last_name"
                  onKeyDown={(event) => {
                    if (/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  {...register("last_name", {
                    required: "This is required.",
                  })}
                />
                {errors.last_name && (
                  <ErrorLabel message={errors.last_name?.message} />
                )}
              </div>
            </div> */}
            {/* <div className="mb-3 row">
              <label for="mobile" className="form-label col-sm-4">
                Mobile Number
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="mobile"
                  name="mobile"
                  disabled={true}
                  onKeyDown={(event) => {
                    if (/![0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  {...register("mobile", {
                   
                  })}
                />
                {}
              </div>
            </div> */}
            {/* <div className="mb-3 row">
              <label for="email" className="form-label col-sm-4">
                Email Id <span className="text-danger">*</span>
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  name="email"
                  {...register("email", {
                    required: "This is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "invalid email address",
                    },
                  })}
                />
                {errors.email && <ErrorLabel message={errors.email?.message} />}
              </div>
            </div> */}
            {/* <div className="mb-3 row">
              <label for="alt_contact" className="form-label col-sm-4">
                Alternate Contact Number
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="alt_contact"
                  maxLength={10}
                  name="alt_contact"
                  {...register("alt_contact", {
                    // required: "This is required.",
                    pattern: {
                      value: /^[0-9]{10}$/i,
                      message: "invalid mobile number",
                    },
                  })}
                />
                {errors.alt_contact && (
                  <ErrorLabel message={errors.alt_contact?.message} />
                )}
              </div>
            </div> */}
            {/* <div className="mb-3 row">
              <label for="alt_email" className="form-label col-sm-4">
                Alternate Email Address
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="alt_email"
                  name="alt_email"
                  {...register("alt_email", {
                    // required: "This is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "invalid email address",
                    },
                  })}
                />
                {errors.alt_email && (
                  <ErrorLabel message={errors.alt_email?.message} />
                )}
              </div> */}
            {/* </div> */}
            {/* <div className="mb-3 row">
              <label for="remarks" className="form-label col-sm-4">
                Remarks
              </label>
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  id="remarks"
                  name="remarks"
                  {...register("remarks", {
                    // required: "This is required.",
                  })}
                />
                {errors.remarks && (
                  <ErrorLabel message={errors.remarks?.message} />
                )}
              </div>
            </div> */}
            {/* <div className="col-12 mt-4 text-center">
              <div
                {...getRootProps({ className: "dropzone" })}
                className="border-dashed text-center p-3 bg-light rounded border-secondary shadow"
              >
                <span className="badge bg-primary rounded p-2">
                  <input accept="" {...getInputProps()} />
                  <i className="fa fa-plus" />
                </span>{" "}
                <span>Upload Invoice / Policy Related documents</span>
              </div>
              <span id="document-required" className="d-none  text-danger fs-7 mx-auto ">
                {" "}
                Document is required
              </span>
              {thumbs}
              {attachment.length > 1 && (
                <button
                  type="btn"
                  className="btn btn-primary rounded mt-4"
                  onClick={(e) => {
                    e.preventDefault();
                    removeAll();
                  }}
                >
                  Remove All
                </button>
              )}
              {fileRejectionItems}
            </div> */}
            <div className="form-group row justify-content-center mt-5">
              <div className="col-sm-5 submit-btn">
                {isLoader === true ? (
                  <Loader />
                ) : (
                  <button type="submit" className="w-100 btn btn-primary">

                    Submit

                  </button>
                )}
                {/* START */}
                {/* <p className="text-center mt-3 fw-bold">OR share Link</p>
                                <div className="input-group input-focus mt-3">
                                <input ref={textAreaRef} type="text" placeholder="https://link.pincinsurance.com/form/car" value="https://link.pincinsurance.com/form/car" className="form-control border-left-0 " />
                                <span className="input-group-text bg-white cursor-pointer" onClick={copyToClipboard}><i className="fa fa-copy"></i></span>
                              </div>
                              <p className="text-success text-center mt-2">{copySuccess}</p> */}
                {/* END */}
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NewVehicle;
